
const URLs = {
  home: '/hulum-ecommerce',
  signIn: '/login',
  register: '/register',
  products: '/products',
  productDetail: '/products/detail'
}

export default URLs;